// extracted by mini-css-extract-plugin
export default {"wrapper":"progressBar_wrapper__Ie46V","progress":"progressBar_progress__et7Ck"};